import _useAnonymousMatterQuery from "./__generated__/useAnonymousMatterQuery.graphql";
import { graphql, useLazyLoadQuery } from "@workflows/runtime-web";
import { useAnonymousMatterQuery } from "./__generated__/useAnonymousMatterQuery.graphql";
export const useAnonymousMatter = (id: string, code: string, tenantId: string) => {
  return useLazyLoadQuery<useAnonymousMatterQuery>(Query, {
    matterId: id,
    code,
    tenantId
  });
};
const Query = (_useAnonymousMatterQuery.hash && _useAnonymousMatterQuery.hash !== "7ed0c795706fa6ceb563118ef39406ce" && console.error("The definition of 'useAnonymousMatterQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _useAnonymousMatterQuery);